export const CRM_AI_ENABLED =
  import.meta.env.VITE_ENABLE_CRM_AI?.trim().toLowerCase() === 'true';
